import React from "react";
import folderIcon from "../../../assets/vw/svg/archivo.svg";
import fileIcon from "../../../assets/vw/svg/file-icon.svg";
import imageIcon from "../../../assets/vw/svg/image-icon.svg";

const FILE_TYPE_ICON_MAP = {
  jpg: "IMAGE",
  jpeg: "IMAGE",
  png: "IMAGE",
};

const getExtension = (key = "") => {
  const fileName = key.split("/").filter(Boolean).pop() || "";
  const extension = fileName.includes(".") ? fileName.split(".").pop() : "";
  return extension.toLowerCase();
};

export const isImageFile = (item = {}) => ["jpg", "jpeg", "png"].includes(getExtension(item?.Key));

export const getLibraryItemName = (item = {}) => {
  if (!item) return "";
  if (item.__isPrefix) return item.Key?.replace(/\/$/, "") || item.Key;
  return item.Key?.split("/").filter(Boolean).pop() || item.Key;
};

export const FileTypeIcon = ({ item, className = "" }) => {
  if (item.__isPrefix) {
    return (
      <img
        src={folderIcon}
        className={`libreria-generic-file-icon ${className}`}
        alt="Carpeta"
      />
    );
  }

  const extension = getExtension(item.Key);
  const label = FILE_TYPE_ICON_MAP[extension] || "FILE";

  if (label === "IMAGE") {
    return (
      <img
        src={imageIcon}
        className={`libreria-generic-file-icon ${className}`}
        alt="Imagen"
      />
    );
  }

  if (label === "FILE") {
    return (
      <img
        src={fileIcon}
        className={`libreria-generic-file-icon ${className}`}
        alt="Archivo"
      />
    );
  }

  return (
    <span
      className={`libreria-file-type-icon libreria-file-type-icon--${label.toLowerCase()} ${className}`}
      aria-label={`Archivo ${label}`}
      role="img"
    >
      {label}
    </span>
  );
};
